import React from "react"
import Img from "gatsby-image"
import IconStyle from "./icon.module.css"
const Icon = ({ Icon, Subtitle }) => (
  <div className={IconStyle.onethird}>
    <Img className={IconStyle.iconimg} fluid={Icon} />
    <p className={IconStyle.icontext}>{Subtitle}</p>
  </div>
)
export default Icon
